import React, { useContext, useEffect, useMemo, useState } from "react";
import { AppContext } from "../../../../providers/appProvider"

import { useTranslation } from "react-i18next";
import Select from "react-select";
import css from "./Calculator.module.css";
import { selectStyle } from "./selectStyle";
import { useTitle } from "../../../../hooks/useTitle";

const TitleCheck = () => {
  const { titleService } = useTitle();
  const { t } = useTranslation();
  const [selectedTitleId, setSelectedTitleId] = useState(null);
  const { app } = useContext(AppContext);

  useEffect(() => {
    titleService.fetch();
  }, []);

  const options = useMemo(
    () =>
      titleService.items.map((item) => ({
        value: item.id,
        label: item.title,
      })),
    [titleService.items]
  );

  const selectedOption = useMemo(() => {
    if (selectedTitleId == null) return null;
    return options.find((opt) => opt.value === selectedTitleId) || null;
  }, [options, selectedTitleId]);

  const selectedTitle = useMemo(() => {
    if (selectedTitleId == null) return null;
    return titleService.items.find((item) => item.id === selectedTitleId) || null;
  }, [selectedTitleId, titleService.items]);

  return (
    <div className={css.colBox}>
      <h1 className={css.colTitle}>{t("TitleCheck")}</h1>
      <div className={css.bigtran}>
        <div className={css.horTitle}>{t("Title")}</div>
        <Select
          value={selectedOption}
          onChange={(opt) => setSelectedTitleId(opt?.value ?? null)}
          options={options}
          isClearable
          isLoading={titleService.isLoading}
          placeholder={titleService.isLoading ? `${t("Loading")}...` : t("SelectTitle")}
          styles={selectStyle}
        />
      </div>

      <div className={css.transPriceBottom}>
        <div className={css.bigtran} style={{ padding: "5px 20px 10px 20px" }}>

          <div className={css.commentBox}>
            <div className={css.horTitle}>{t("Comment")}</div>

            {selectedTitle && <>{selectedTitle.description || "-"}</>}
          </div>
        </div>


        {app.hasPermission("TITLE_DEALER_COST_SHOW") &&

          <div className={css.TitlePrice}>
            <div className={css.transText}>{t("DealerCost")}</div>
            <span>{selectedTitle ? selectedTitle.cost_for_dealers ?? 0 : 0} $</span>
          </div>

        } 

        {app.hasPermission("TITLE_RETAIL_COST_SHOW") &&
          <div className={css.TitlePrice}>
            <div className={css.transText}>{t("RetailCost")}</div>
            <span>{selectedTitle ? selectedTitle.cost_for_retail ?? 0 : 0} $</span>
          </div> 

        }

      </div>
    </div>
  );
};

export default TitleCheck;
